import type { MessageInstance, ModalStaticFunctions, NotificationInstance } from 'antd/es/message';

interface AntdAppAPI {
  message: MessageInstance;
  notification: NotificationInstance;
  modal: ModalStaticFunctions;
}

let antdApp: AntdAppAPI | null = null;

export const setAntdApp = (app: AntdAppAPI) => {
  antdApp = app;
};

export const getAntdApp = (): AntdAppAPI => {
  if (!antdApp) {
    throw new Error('AntdApp not initialized. Make sure <App> from antd is rendered.');
  }
  return antdApp;
};
